// Importing necessary React hooks and components

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SharedFlag from "./pages/SharedFlag.jsx";
import Homepage from "./pages/Homepage.jsx";

var serviceAccount = require("./serviceAccountKey.json");
export const app = initializeApp(serviceAccount);
export const db = getFirestore(app);
export const auth = getAuth(app);

// Main App component responsible for rendering the entire application
function App() {
  // Render the main App component
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Homepage />} />
        <Route
          path="/flag/:uuid"
          element={
            <div
              style={{
                maxWidth: "700px",
                height: "900px",
                margin: "0 auto",
              }}
            >
              {<SharedFlag />} {/* Render the determined content */}
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

// Exporting the App component as the default export
export default App;
